import { universalFetch } from "./common";
import type { MainProfile } from "../interfaces/mainProfile";

export const fetchAccountData = async (): Promise<MainProfile> => {
  try {
    const response = await universalFetch("/auth/check", "GET");
    console.log("fetchAccountData response:", response);
    return response as MainProfile;
  } catch (error) {
    console.error("Failed to fetchAccountData", error);
    throw error;
  }
};
